const TabWrapper = ({ children }) => (
  <div className="scrollbar w-full md:h-[520px] overflow-scroll">
    {children}
  </div>
);

export default TabWrapper;
